import axios from 'axiosConfig';

export const deleteLoanOfficer = (LoanOfficerID) => axios.delete(`/api/loanofficer/deleteloanofficer/${LoanOfficerID}`);

export const addLoanOfficer = (newLoanOfficer) => axios.post("/api/loanofficer/addloanofficer", newLoanOfficer, {});

export const getAllLoanOfficer = (userID) => axios.get("/api/loanofficer/getloanofficers", {});

export const updateLoanOfficer = (LoanOfficer) => axios.put("/api/loanofficer/updateloanofficer", LoanOfficer, {});

